import { render } from "./CampaignDetail.vue?vue&type=template&id=3f090b9e&scoped=true"
import script from "./CampaignDetail.vue?vue&type=script&lang=js"
export * from "./CampaignDetail.vue?vue&type=script&lang=js"

import "./CampaignDetail.vue?vue&type=style&index=0&id=3f090b9e&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f090b9e"]])

export default __exports__